/**
 * Login
 *
 * @author edmsamuel
 */
import React from 'react'
import Api from '../Api'
import { Form, Button, message as Message, Input } from 'antd'
import Exception from '../Exception'

class LoginForm extends React.Component {
  constructor(props) {
    super(props)
    this.authenticate = this.authenticate.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  /**
   * On Submit
   *
   */
  onSubmit(e) {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.authenticate(values)
      }
    })
  }

  /**
   * Solicita al servidor que se verifiquen las credenciales
   *
   * @param {Object} credentials
   */
  authenticate(credentials) {
    const CloseLoading = Message.loading('Iniciando Sesión', 0)
    Api.post('/usuarios/auth', credentials)
      .then(response => {
        CloseLoading()
        Message.success(`Bienvenido ${response.data.sNombre}`)

        if (this.props.onLoginOk) {
          this.props.onLoginOk(response.data)
        }
      })
      .catch(error => {
        CloseLoading()
        Message.error((new Exception(error)).toComponent())
      })
  }

  /**
   * Get Field
   *
   * @param {String} name
   */
  getField(name) {
    const options = {
      identificador: {
        rules: [{ required: true, message: 'Usuario' }]
      },
      clave: {
        rules: [{ required: true, message: 'Contraseña' }]
      },
    }

    switch (name) {
      case 'identificador':
        return this.props.form.getFieldDecorator(name, options[name])(
          <Input
            placeholder='Usuario'
          />
        )

      case 'clave':
        return this.props.form.getFieldDecorator(name, options[name])(
          <Input
            type='password'
            placeholder='Contraseña'
          />
        )

      default:
        return null
    }
  }

  /**
   * Render
   *
   */
  render() {
    return (
      <Form onSubmit={this.onSubmit} className='login-form'>
        <Form.Item>{this.getField('identificador')}</Form.Item>
        <Form.Item>{this.getField('clave')}</Form.Item>
        <Form.Item>
          <Button type='primary' htmlType='submit' className='login-form-button'>Ingresar</Button>
          {/* <br/>
          <Link to={buildPath('/registro')}>¡Registro!</Link>
          <Divider type='vertical' />
          <Link to={buildPath('/forgot')}>Contraseña perdida</Link> */}
        </Form.Item>
      </Form>
    )
  }
}

const Login = Form.create()(LoginForm)
export default Login
